export const undefinedToNull = (a: any) => (typeof a === "undefined" ? null : a);

export const isNull = (a: any): a is null => a === null;

export const isUndefined = (a: any): a is undefined => typeof a === "undefined";

export const isNullOrUndefined = (a: any): a is null | undefined => isNull(a) || isUndefined(a);
